// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3pUve","title":"Info_title__g92da","selects":"Info_selects__2Mwbj","requiredAsterisk":"Info_requiredAsterisk__YbnY_"};